module.exports = [
  require('./to')
];


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/unit/index.js
// module id = 1279
// module chunks = 0